import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Testimonials from '../../testimonials/testimonials';

const TestimonialsBlock = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <Spacing pt={paddingTop} pb={paddingBottom}>
      <Container bg={'primary'}>
        <Spacing pt={8} pb={8}>
          <Testimonials {...props} name={props.__typename} />
        </Spacing>
      </Container>
    </Spacing>
  );
};

export default TestimonialsBlock;

export const query = graphql`
  fragment TestimonialsBlock on DatoCmsTestimonialsBlock {
    id: originalId
    paddingTop
    paddingBottom
    items {
      quote
      name
      company
    }
    __typename
  }
`;
